'use strict'

/**
 * Block #place_order (and any wallet button inside #dokan-stripe-express-element)
 * from starting payment when the user has picked Google Pay / Apple Pay / Link
 * inside Stripe Express and the checkout form is not yet valid.
 *
 * The guard is intentionally scoped: for every other payment method (card,
 * bank transfer, Maksekeskus, …) we do nothing and let WooCommerce's native
 * checkout validation run as usual.
 *
 * Invalid state is read from the body classes maintained by the custom
 * Omniva plugin's parcelmachines.js:
 *   .custom-omniva-wallet-form-invalid — required field empty or terms unchecked
 *   .custom-omniva-wallet-gated        — parcel-machine shipping picked but
 *                                        no machine selected
 *
 * Wallet detection uses the hidden input the Dokan Stripe Express plugin
 * writes on every Payment Element change (see Checkout.tsx:413):
 *   #dokan-stripe-express-payment-type ∈ {card, apple_pay, google_pay, link, …}
 */
$(function () {
    if (!$('body').hasClass('woocommerce-checkout')) return;

    const messageId = 'lr-place-order-guard-message';
    const disabledClass = 'lr-place-order-disabled';
    const walletTypes = ['apple_pay', 'google_pay', 'link'];

    const messages = {
        gated: 'Lūdzu, izvēlieties pakomātu, lai turpinātu ar Google Pay / Apple Pay.',
        invalid: 'Lūdzu, aizpildiet visus obligātos laukus un piekrītiet noteikumiem, lai turpinātu ar Google Pay / Apple Pay.'
    };

    const getForm = () => $('form.woocommerce-checkout, form.checkout').first();
    const getPlaceOrder = () => $('#place_order');

    const isWalletFlow = () => {
        const method = (getForm().find('input[name="payment_method"]:checked').val() || '').toString();
        if (method !== 'dokan_stripe_express') return false;
        const type = ($('#dokan-stripe-express-payment-type').val() || '').toString().toLowerCase();
        return walletTypes.indexOf(type) !== -1;
    };

    const getInvalidReason = () => {
        const $body = $('body');
        if ($body.hasClass('custom-omniva-wallet-gated')) return 'gated';
        if ($body.hasClass('custom-omniva-wallet-form-invalid')) return 'invalid';
        return null;
    };

    const ensureMessage = () => {
        let $msg = $('#' + messageId);
        if (!$msg.length) {
            const $btn = getPlaceOrder();
            if (!$btn.length) return $();
            $msg = $('<div/>', {
                id: messageId,
                class: 'lr-place-order-guard-message',
                role: 'alert'
            }).hide();
            $btn.before($msg);
        }
        return $msg;
    };

    const clearGuardUI = () => {
        const $btn = getPlaceOrder();
        if (!$btn.length) return;
        $btn.prop('disabled', false)
            .removeAttr('aria-disabled')
            .removeClass(disabledClass);
        $('#' + messageId).hide();
    };

    const update = () => {
        // Guard is inert unless a wallet flow is active. Native WooCommerce
        // validation handles card / non-wallet payments.
        if (!isWalletFlow()) { clearGuardUI(); return; }

        const reason = getInvalidReason();
        if (!reason) { clearGuardUI(); return; }

        const $btn = getPlaceOrder();
        if (!$btn.length) return;
        const $msg = ensureMessage();

        $btn.prop('disabled', true)
            .attr('aria-disabled', 'true')
            .addClass(disabledClass);
        $msg.text(messages[reason]).show();
    };

    // Capture-phase click guard — only fires when a wallet flow is active
    // AND the form is invalid. Otherwise the click falls through to WooCommerce's
    // own submit handler (and its native validation) untouched.
    document.addEventListener('click', function (e) {
        const t = e.target && e.target.closest ? e.target.closest('#place_order, #dokan-stripe-express-element button, #dokan-stripe-express-payment-request-button') : null;
        if (!t) return;
        if (!isWalletFlow()) return;
        const reason = getInvalidReason();
        if (!reason) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const $msg = ensureMessage();
        if ($msg.length) {
            $msg.text(messages[reason]).show();
            $('html, body').animate({ scrollTop: $msg.offset().top - 120 }, 300);
        }
    }, true);

    // Re-evaluate on every event that could change either wallet-selection or
    // form validity. Payment-type changes fire on the hidden input itself.
    $(document).on('change input', 'form.checkout :input, form.woocommerce-checkout :input', update);
    $(document).on('change', '#custom_omniva, #dokan-stripe-express-payment-type', update);
    $(document.body).on(
        'updated_checkout country_to_state_changed applied_coupon removed_coupon payment_method_selected',
        update
    );

    // The Payment Element writes to #dokan-stripe-express-payment-type via
    // .val() without firing 'change' — mirror what the plugin does elsewhere
    // and observe the attribute directly.
    if (window.MutationObserver) {
        new MutationObserver(update).observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });
        const paymentTypeEl = document.getElementById('dokan-stripe-express-payment-type');
        if (paymentTypeEl) {
            new MutationObserver(update).observe(paymentTypeEl, {
                attributes: true,
                attributeFilter: ['value']
            });
        }
    }
    // Belt-and-braces: poll while the checkout is open — the hidden input's
    // value is set via jQuery .val() which triggers neither 'change' nor a DOM
    // attribute mutation, so nothing else would notice a wallet was picked.
    setInterval(update, 500);

    update();
    setTimeout(update, 1000);
});
